"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportingFactory = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const react_virtualized_auto_sizer_1 = __importDefault(require("react-virtualized-auto-sizer"));
const split_screen_1 = require("../../components/split-screen/split-screen");
const report_definitions_1 = require("./components/report-definitions");
const report_detail_1 = require("./components/report-detail");
const screen_mode_hook_1 = require("./hook/screen-mode-hook");
const reporting_styles_1 = require("./reporting-styles");
function reportingFactory({ exportTag }) {
    return function Reporting() {
        const intl = (0, react_intl_1.useIntl)();
        const classes = (0, reporting_styles_1.useStyles)();
        const { splitScreenRef } = (0, screen_mode_hook_1.useScreenMode)();
        const [selected, setSelected] = (0, react_1.useState)();
        return (react_1.default.createElement("div", { className: classes.evidence },
            react_1.default.createElement(react_virtualized_auto_sizer_1.default, { disableWidth: true }, ({ height }) => (react_1.default.createElement("div", { style: { height, display: 'flex' } },
                react_1.default.createElement(split_screen_1.SplitScreen, { ref: splitScreenRef, rightLabel: intl.formatMessage({
                        id: 'EAS_REPORTING_SPLIT_DATA',
                        defaultMessage: 'Report',
                    }), leftLabel: intl.formatMessage({
                        id: 'EAS_REPORTING_SPLIT_DEFINITIONS',
                        defaultMessage: 'Výběr',
                    }), defaultTitle: document.title },
                    react_1.default.createElement(report_definitions_1.ReportDefinitions, { selected: selected, onSelect: setSelected }),
                    react_1.default.createElement(report_detail_1.ReportDetail, { exportTag: exportTag, definition: selected })))))));
    };
}
exports.reportingFactory = reportingFactory;
//# sourceMappingURL=reporting.js.map